import script from "./GroupDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupDetails.vue?vue&type=script&setup=true&lang=ts"

import "./GroupDetails.vue?vue&type=style&index=0&id=291ec2e8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-291ec2e8"]])

export default __exports__